import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

import { ReactComponent as ResourcesIcon } from "assets/bookmark.svg";
import { ReactComponent as HealthIcon } from "assets/Health.svg";
import { ReactComponent as TrainingIcon } from "assets/training.svg";
import { ReactComponent as IndexIcon } from "assets/index.svg";
import { useUserStatus } from "hooks";
import { UserStatus } from "state";
import { Wrapper } from "./styled";
import { mobileNavPaths } from "./util";
import { useSelector } from "react-redux";
import { getUser } from "state";
import { Box } from "@material-ui/core";
import ConfirmationModal from "../ConfirmationModal";
import { ReactComponent as ResourcesLightIcon } from "assets/resource_light.svg";
import { ReactComponent as TrainingLightIcon } from "assets/training_light.svg";
import { useQuery } from "@apollo/react-hooks";
import { UserEnrollmentConsent } from "graphql/user/user.gql";

interface MobileNavProps {
  show?: boolean;
  isRefactorEnabled: boolean;
  isResourceEnabled: boolean;
  isTrainingEnabled: boolean;
  isAssessmentEnabled: boolean;
  mobileTab: number;
  isAssessmentNotStartedOrInProgress: boolean;
  setMobileTab: React.Dispatch<React.SetStateAction<number>>;
  handleMobileNavChange: (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => void;
}

const getTab = (location: string): number => {
  switch (location) {
    case "/dashboard":
      return 1;
    case "/index":
      return 2;
    case "/training":
      return 3;
    case "/resources":
      return 4;
    default:
      return 0;
  }
};

const SimpleBottomNavigation: React.FC<MobileNavProps> = ({
  show,
  isRefactorEnabled,
  isResourceEnabled,
  isTrainingEnabled,
  isAssessmentEnabled,
  mobileTab,
  isAssessmentNotStartedOrInProgress,
  setMobileTab,
  handleMobileNavChange
}: MobileNavProps) => {
  const userStatus = useUserStatus();
  const history = useHistory();

  const location = useLocation().pathname;
  const mobileNav = mobileNavPaths.some(
    path => path === location || location.includes(path + "/")
  );

  const [
    showAssessmentConfirmationModal,
    setShowAssessmentConfirmationModal
  ] = useState(false);

  const [enrollmentConsent, setEnrollmentConsent] = useState<boolean>(false);

  const { data, refetch } = useQuery(UserEnrollmentConsent);

  useEffect(() => {
    if (data) {
      setEnrollmentConsent(data?.me?.enrollmentConsent);
    }
  }, [data]);

  useEffect(() => {
    refetch().catch(() => {
      console.error("Error refetching user enrollment consent:");
    });
  }, [location, refetch]);

  useEffect(() => {
    setMobileTab(getTab(location));
  }, [location]);

  const user = useSelector(getUser);
  const sammonsUser =
    user?.organization?.name === "sammons" ||
    user?.organization?.name === "goldman-sachs" ||
    user?.organization?.name === "pitt-crew" ||
    user?.organization?.name === "bbs psych pilot";

  return (
    <>
      {(mobileNav || show) && (
        <Wrapper>
          <BottomNavigation
            className="mobile-nav-footer"
            value={mobileTab}
            onChange={handleMobileNavChange}
            showLabels
          >
            {/* not puting this in styled because it's a placeholder for the tabs to have an unset state */}
            <BottomNavigationAction style={{ display: "none" }} />
            {userStatus !== UserStatus.DISQUALIFIED && (
              <BottomNavigationAction
                label="Dashboard"
                icon={<HealthIcon />}
                component={Link}
                to="/dashboard"
              />
            )}
            {isRefactorEnabled && !sammonsUser && (
              <BottomNavigationAction
                label="Index"
                icon={<IndexIcon />}
                component={Link}
                to="/index"
              />
            )}
            {userStatus !== UserStatus.DISQUALIFIED &&
              isTrainingEnabled &&
              enrollmentConsent &&
              (isAssessmentNotStartedOrInProgress && isAssessmentEnabled ? (
                <BottomNavigationAction
                  onClick={() => setShowAssessmentConfirmationModal(true)}
                  icon={<TrainingLightIcon />}
                  label={<Box sx={{ color: "#D3D2D2" }}>Training</Box>}
                />
              ) : (
                <BottomNavigationAction
                  label="Training"
                  icon={<TrainingIcon />}
                  component={Link}
                  to="/training"
                />
              ))}
            {(!enrollmentConsent || isResourceEnabled) &&
              (enrollmentConsent &&
              isAssessmentNotStartedOrInProgress &&
              isAssessmentEnabled ? (
                <BottomNavigationAction
                  onClick={() => setShowAssessmentConfirmationModal(true)}
                  icon={<ResourcesLightIcon />}
                  label={<Box sx={{ color: "#D3D2D2" }}>Resources</Box>}
                />
              ) : (
                <BottomNavigationAction
                  label="Resources"
                  icon={<ResourcesIcon />}
                  component={Link}
                  to="/resources"
                />
              ))}
          </BottomNavigation>
          {showAssessmentConfirmationModal && (
            <ConfirmationModal
              title="Complete Your Index"
              content="Index data drives research—finish to unlock  access this section "
              confirmText="Go to Assessment"
              cancelText="Return"
              onConfirm={async () => {
                setShowAssessmentConfirmationModal(false);
                history.push("/assessment-overview");
              }}
              onCancel={() => setShowAssessmentConfirmationModal(false)}
            />
          )}
        </Wrapper>
      )}
    </>
  );
};

export default SimpleBottomNavigation;
